import React, { useState, useEffect, useRef } from "react";
import "./LoginForm.scss";
import logo_green from "../../img/logo_green.svg";
import { Button } from "../Button/Button";
import gsap from "gsap";
import backArrow from "../../img/backArrow.png";
import { loginUser } from "../../actions/auth-actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { JoinForm } from "./JoinForm";
import { EmailReset } from "./EmailReset";
import { CodePassword } from "./CodePassword";
import { NewPassword } from "./NewPassword";
import { Spinner } from "../Spinner";
import { ArrowLeftOutlined } from "@ant-design/icons";

//@ts-ignore
export interface ILoginFormProps {
  setSuccess: (val: boolean) => void;
  success: boolean;
}

export default function LoginForm(props: ILoginFormProps) {
  const [code, setCode] = useState([".", ".", ".", "."]);
  const [forgot, setForgot] = useState<string>("center");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [reset, setReset] = useState<string | boolean>(false);
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const formRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state.auth);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  //@ts-ignore
  const handleChangeCode = (otp) => setCode({ otp });

  useEffect(() => {
    if (props.success) setForgot("center");
  }, [props.success]);

  useEffect(() => {
    if (formRef.current) {
      gsap.fromTo(
        formRef.current,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.6, ease: "power3.out" }
      );
    }
  }, [forgot, reset]);

  return (
    <div className="login_form_container" ref={formRef}>
      {forgot === "center" ? (
        <div className="login_form_container_initial">
          <div className="login_form_forgot_top">
            <img
              src={logo_green}
              alt="logo Demco"
              className="login_form_logo"
            />
          </div>

          <div className="title_header">
            <h2 className="h2_subtitle_light_blue_login">take off with us</h2>
            <h2 className="h2_subtitle_blue_login_2 h2_subtitle_blue_login">
              WELCOME
            </h2>
            <form className="main_login_form">
              <div className="field">
                <input
                  type="text"
                  name="email"
                  id="email"
                  placeholder=""
                  onChange={handleChange}
                  style={{
                    borderBottom: auth.error && "1px solid red",
                  }}
                />
                <label htmlFor="email" className="login_email_label">
                  Email Address
                </label>
                {auth.error && (
                  <i className="fas fa-exclamation-triangle text-danger"></i>
                )}
              </div>

              <div className="field">
                <input
                  type="password"
                  name="password"
                  id="password"
                  placeholder=""
                  onChange={handleChange}
                  style={{
                    borderBottom: auth.error && "1px solid red",
                  }}
                />
                <label htmlFor="password" className="login_password_label">
                  Password
                </label>
                {auth.error && (
                  <i className="fas fa-exclamation-triangle text-danger"></i>
                )}
              </div>

              <p
                className="forget_password"
                onClick={() => {
                  setForgot("something");
                }}
              >
                Forgot Your Password?
              </p>

              {auth.isLoading ? (
                <Spinner />
              ) : (
                <Button
                  buttonClass="submit_button_white_full_width"
                  innerButton="Sign in"
                  onClick={() => dispatch(loginUser(data))}
                />
              )}
            </form>
          </div>
          <p className=" join_question">
            Don’t have an account ?{" "}
            <span
              className="resend_text"
              onClick={() => setForgot("join")}
              style={{ fontWeight: "bold" }}
            >
              {" "}
              Join DEMCO{" "}
            </span>
          </p>
        </div>
      ) : forgot === "join" ? (
        <JoinForm setSuccess={props.setSuccess} setForgot={setForgot} />
      ) : (
        <div className="login_form_container_initial h-100 d-flex flex-column justify-content-around">
          <div className="login_form_forgot_top">
            <div className="back_arrow_back_link">
              <div
                className="login_go_back"
                onClick={() => {
                  setReset(false);
                  setForgot("center");
                }}
              >
                <ArrowLeftOutlined
                  onClick={() => {
                    setReset(false);
                    setForgot("center");
                  }}
                ></ArrowLeftOutlined>{" "}
                <button className={"go_back_text"}>Go back</button>
              </div>
            </div>
            <img
              src={logo_green}
              alt="logo Demco"
              className="login_form_logo"
            />
          </div>
          {!reset ? (
            <EmailReset
              setReset={setReset}
              setEmail={(x) => setEmail(x)}
              email={email}
            />
          ) : reset === "SendCode" ? (
            <CodePassword
              setReset={setReset}
              handleChangeCode={handleChangeCode}
              code={code}
              email={email}
            />
          ) : (
            <NewPassword
              setForgot={setForgot}
              setPassword={setPassword}
              setConfirmPwd={setConfirmPwd}
              password={password}
              confirmPwd={confirmPwd}
              code={code}
              email={email}
            />
          )}
        </div>
      )}
    </div>
  );
}
